'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _statusComparators = require('conversations-async-data/async-data/operators/statusComparators');

var _ChatHeadingConfigPropType = require('ui-addon-conversations/chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _getThreadsAsyncData = require('../threads/selectors/getThreadsAsyncData');

var _getThreadList = require('../threads/selectors/getThreadList');

var _getColoring = require('../selectors/widgetDataSelectors/getColoring');

var _getChatHeadingConfig = require('../chat-heading-config/selectors/getChatHeadingConfig');

var _navigateToExistingThread = require('../navigation/actions/navigateToExistingThread');

var _ThreadList = require('../threads/components/ThreadList');

var _ThreadList2 = _interopRequireDefault(_ThreadList);

var _LoadingState = require('../components/LoadingState');

var _LoadingState2 = _interopRequireDefault(_LoadingState);

var _VisitorWidgetContainer = require('../visitor-widget/containers/VisitorWidgetContainer');

var _VisitorWidgetContainer2 = _interopRequireDefault(_VisitorWidgetContainer);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

var _getSendFromResponders = require('../responders/selectors/getSendFromResponders');

var _getAgentRespondersList = require('../responders/selectors/getAgentRespondersList');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThreadListContainer = _react2.default.createClass({
  displayName: 'ThreadListContainer',

  propTypes: {
    agentRespondersList: _react.PropTypes.instanceOf(_immutable.List).isRequired,
    browserWindowHeight: _react.PropTypes.number.isRequired,
    chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
    coloring: (0, _RecordPropType2.default)('ColoringRecord'),
    inline: _react.PropTypes.bool.isRequired,
    isLoading: _react.PropTypes.bool.isRequired,
    isOpen: _react.PropTypes.bool,
    launcherRef: _react.PropTypes.object,
    navigateToExistingThread: _react.PropTypes.func.isRequired,
    onUpdateOpened: _react.PropTypes.func.isRequired,
    onUpdateSize: _react.PropTypes.func.isRequired,
    sendFromResponders: _react.PropTypes.instanceOf(_immutable.List).isRequired,
    threadList: _react.PropTypes.instanceOf(_immutable.List)
  },

  handleSelectThread: function handleSelectThread(threadId) {
    this.props.navigateToExistingThread({ threadId: threadId });
  },
  renderLoadingState: function renderLoadingState() {
    return _react2.default.createElement(_LoadingState2.default, null);
  },
  renderThreadList: function renderThreadList() {
    return _react2.default.createElement(_ThreadList2.default, {
      coloring: this.props.coloring,
      threadList: this.props.threadList,
      chatHeadingConfig: this.props.chatHeadingConfig,
      onSelectThread: this.handleSelectThread,
      sendFromResponders: this.props.sendFromResponders,
      agentRespondersList: this.props.agentRespondersList
    });
  },
  render: function render() {
    var content = this.props.isLoading ? this.renderLoadingState() : this.renderThreadList();

    return _react2.default.createElement(
      _VisitorWidgetContainer2.default,
      {
        browserWindowHeight: this.props.browserWindowHeight,
        inline: this.props.inline,
        isOpen: this.props.isOpen,
        launcherRef: this.props.launcherRef,
        onUpdateOpened: this.props.onUpdateOpened,
        onUpdateSize: this.props.onUpdateSize,
        viewingThreadList: true
      },
      content
    );
  }
});

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    isLoading: !(0, _statusComparators.isSucceeded)((0, _getThreadsAsyncData.getThreadsAsyncData)(state)),
    coloring: (0, _getColoring.getColoring)(state),
    threadList: (0, _getThreadList.getThreadList)(state),
    chatHeadingConfig: (0, _getChatHeadingConfig.getChatHeadingConfig)(state),
    sendFromResponders: (0, _getSendFromResponders.getSendFromResponders)(state),
    agentRespondersList: (0, _getAgentRespondersList.getAgentRespondersList)(state)
  };
}, {
  navigateToExistingThread: _navigateToExistingThread.navigateToExistingThread
})(ThreadListContainer);
module.exports = exports['default'];